import { useSelector } from 'react-redux'
import { useMemo } from 'react'

import {
  selectWorkspaces,
  selectCurrentWorkspace,
} from '../slices/workspaceSlice'
import { selectAuthUser } from '../slices/userSlice'
import { CollaboratorPermissions } from '../../lib/db/db.types'

export const usePermissions = () => {
  const userId = useSelector(selectAuthUser)?.id
  const currentWorkspaceId = useSelector(selectCurrentWorkspace)
  const workspaces = useSelector(selectWorkspaces)

  const workspace = useMemo(() => {
    return workspaces.find((b) => b.id === currentWorkspaceId)
  }, [workspaces, currentWorkspaceId])

  const collaborators = useMemo(() => {
    return workspace?.collaborators ?? {}
  }, [workspace])

  const permissions = useMemo((): CollaboratorPermissions => {
    if (!userId) return {}
    const collaborator = collaborators[userId]
    return collaborator?.permissions ?? {}
  }, [collaborators, userId])

  const isOwner = permissions.isOwner || false

  return {
    isOwner,
    canManageTeam: isOwner,
    canManageEvents: permissions.canManageEvents || isOwner,
    canManageReminders: permissions.canManageReminders || isOwner,
    canManageDocuments: permissions.canManageDocuments || isOwner,
  }
}
